import { FEATURE_PLAN_MAP, type FeatureKey, type PlanId, planIncludesFeature } from '@/config/access-control'
import { useCurrentPlan } from './useCurrentPlan'

export type FeatureAccessResult =
	| { allowed: true; requiredPlan: PlanId | null; currentPlan: PlanId | null }
	| { allowed: false; reason: 'plan-locked'; requiredPlan: PlanId; currentPlan: PlanId }

/** Returns plan-gate state for the given feature, failing open as `planIncludesFeature` describes. */
export function useFeatureAccess(featureKey?: FeatureKey): FeatureAccessResult {
	const currentPlan = useCurrentPlan()

	if (!featureKey) {
		return { allowed: true, requiredPlan: null, currentPlan }
	}

	const required = FEATURE_PLAN_MAP[featureKey]

	if (currentPlan == null || planIncludesFeature(currentPlan, featureKey)) {
		return { allowed: true, requiredPlan: required, currentPlan }
	}
	return { allowed: false, reason: 'plan-locked', requiredPlan: required, currentPlan }
}
